module.exports = __webpack_public_path__ + "static/media/spa-4481583_1280.40bebb02.jpg";